<template>

  <div>
    <b-row
      class="content-header"
    >

      <!-- Content Left -->
      <b-col
        class="content-header-left mb-2"
        cols="7"
        md="9"
      >
        <b-row class="breadcrumbs-top">
          <b-col cols="12">
            <h2 class="custom-header-title float-left pr-1 mb-0">
              All Suites
            </h2>
          </b-col>
        </b-row>
      </b-col>

      <!-- Content Right -->
      <b-col
        class="content-header-right text-right mb-1"
        md="3"
        cols="5"
      >
        <!-- <b-button
          v-if="canViewThisAction('create', 'Suite')"
          variant="success"
          class="mobile_create_button"
          :to="{ name: 'products-suites-create' }"
        >
          <feather-icon
            icon="PlusIcon"
            class="mr-50"
            size="16"
          />
          <span class="align-middle d-md-block d-none">Create new Suite</span>
          <span class="align-middle d-md-none d-block">New</span>
        </b-button> -->
      </b-col>
    </b-row>
    <!-- Table Container Card -->
    <b-card
      no-body
      class="mb-0"
    >

      <div class="m-2">

        <!-- Table Top -->
        <b-row>

          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <!-- <span class="text-muted">Showing {{ dataMeta.from }} - {{ dataMeta.to }} of {{ dataMeta.of }}</span> -->
            <feather-icon
              icon="SearchIcon"
              size="18"
              class="mr-50"
            />
            <span class="align-middle">Search</span>

            <b-input-group
              class="input-group-merge mx-50"
            >
              <b-form-input
                v-model="searchQuery"
                placeholder="Suite Name or Code"
              />
              <b-input-group-append
                v-if="searchQuery"
                is-text
              >
                <feather-icon
                  icon="XIcon"
                  class="cursor-pointer"
                  @click="searchQuery = '';"
                />
              </b-input-group-append>
            </b-input-group>
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-dropdown
                id="dropdown-Team-form"
                ref="filter_dropdown_locations"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                class="dropdown-modal"
                right
                variant="link"
              >
                <template #button-content>
                  <feather-icon
                    icon="FilterIcon"
                    size="21"
                    class="align-middle mr-50"
                  />
                  <span class="mr-1">Filters</span>
                </template>
                <suite-filter
                  :location.sync="locationFilter"
                  :location-options="locationOptions"
                  :product.sync="productFilter"
                  :product-options="productOptions"
                  :reservable.sync="reservableFilter"
                  :reservable-options="reservableOptions"
                  :sale-status.sync="saleStatusFilter"
                  :sale-status-options="saleStatusOptions"
                  @emitHideFilter="hideFilter"
                  @emitShowFilter="showFilter"
                />
              </b-dropdown>
            </div>
          </b-col>
        </b-row>
        <div v-if="locationFilter.length || productFilter.length || reservableFilter.length || saleStatusFilter.length">
          <hr class="dividerHR filter-divider">
          <b-row>

            <!-- Per Page -->
            <b-col
              cols="12"
              md="12"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <ul
                class="list-inline d-inline-block mb-1"
              >
                <li
                  v-for="item in locationFilter"
                  :key="item"
                  class="list-inline-item"
                >
                  <b-form-tag
                    class="mb-50"
                    variant="danger"
                    @remove="removeFromLocationFilter(item)"
                  >
                    <span class="text-capitalize">{{ resolveLocationName(item) }}</span>
                  </b-form-tag>
                </li>
                <li
                  v-for="item in productFilter"
                  :key="item"
                  class="list-inline-item"
                >
                  <b-form-tag
                    class="mb-50"
                    variant="danger"
                    @remove="removeFromProductFilter(item)"
                  >
                    <span class="text-capitalize">{{ resolveProductName(item) }}</span>
                  </b-form-tag>
                </li>
                <li
                  v-for="item in reservableFilter"
                  :key="item"
                  class="list-inline-item"
                >
                  <b-form-tag
                    class="mb-50"
                    variant="danger"
                    @remove="removeFromReservableFilter(item)"
                  >
                    <span class="text-capitalize">{{ item }}</span>
                  </b-form-tag>
                </li>
                <li
                  v-for="item in saleStatusFilter"
                  :key="item"
                  class="list-inline-item"
                >
                  <b-form-tag
                    class="mb-50"
                    variant="danger"
                    @remove="removeFromSaleStatusFilter(item)"
                  >
                    <span class="text-capitalize">{{ item }}</span>
                  </b-form-tag>
                </li>
                <li
                  class="list-inline-item"
                >
                  <span
                    class="text-danger clear-filter-text mb-50"
                    @click="clearAllFilters"
                  >
                    Clear Filters
                  </span>
                </li>
              </ul>
            </b-col>
          </b-row>
        </div>
      </div>

      <b-table
        ref="refSuitesTable"
        class="position-relative min-height-table"
        :items="itemListData"
        responsive
        :fields="tableColumns"
        primary-key="_id"
        :sort-by.sync="sortBy"
        show-empty
        no-sort-reset
        empty-text="No matching records found"
        :sort-desc.sync="isSortDirDesc"
      >
        <template #cell(stringID)="data">
          <div class="text-nowrap">
            <b-button
              v-if="canViewThisAction('show', 'Suite')"
              v-ripple.400="'rgba(30, 30, 30, 0.15)'"
              variant="link"
              class="weight-600 align-middle detail-view-id"
              :to="{ name: 'products-suites-show', params: { id: data.item._id } }"
            >
              {{ data.item.stringID }}
            </b-button>
            <b-button
              v-else
              v-ripple.400="'rgba(30, 30, 30, 0.15)'"
              variant="none"
              class="text-bold-black align-middle detail-view-id not-button"
            >
              {{ data.item.stringID }}
            </b-button>
          </div>
        </template>
        <template #cell(image)="data">
          <div>
            <b-img
              class="mb-1 mb-sm-0 user__avatar img-preview-block"
              :src="data.item.image ? data.item.image : defaultImage"
            />
          </div>
        </template>

        <template #cell(location)="data">
          <div
            v-if="data.item.location"
          >
            <b-button
              v-if="canViewThisAction('show', 'SuiteLocation')"
              v-ripple.400="'rgba(30, 30, 30, 0.15)'"
              variant="link"
              class="weight-600 align-middle detail-view-id"
              :to="{ name: 'products-locations-show', params: { id: data.item.location._id } }"
            >
              {{ data.item.location.name }}
            </b-button>
            <b-button
              v-else
              v-ripple.400="'rgba(30, 30, 30, 0.15)'"
              variant="none"
              class="text-bold-black align-middle detail-view-id not-button"
            >
              {{ data.item.location.name }}
            </b-button>
          </div>
          <span v-else>-</span>
        </template>

        <!-- Column: category -->
        <template #cell(reservableBy)="data">
          <div>
            <b-badge
              :variant="`light-${resolveReservableVariant(data.item.reservableBy)}`"
              class="text-capitalize"
            >
              <span>{{ data.item.reservableBy }}</span>
            </b-badge>
          </div>
        </template>

        <template #cell(saleStatus)="data">
          <div>
            <b-badge
              :variant="`light-${resolveSaleStatusVariant(data.item.saleStatus)}`"
              class="text-capitalize"
            >
              <span>{{ data.item.saleStatus }}</span>
            </b-badge>
          </div>
        </template>

        <!-- Column: Actions -->
        <template
          v-if="canViewThisAction('show', 'Suite') || canViewThisAction('update', 'Suite') || canViewThisAction('delete', 'Suite')"
          #cell(actions)="data"
        >
          <b-dropdown
            variant="link"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >

            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>

            <b-dropdown-item
              v-if="canViewThisAction('show', 'Suite')"
              :to="{ name: 'products-suites-show', params: { id: data.item._id } }"
            >
              <span class="align-middle ml-50">View</span>
            </b-dropdown-item>

            <b-dropdown-item
              v-if="canViewThisAction('update', 'Suite')"
              :to="{ name: 'products-suites-edit', params: { id: data.item._id } }"
            >
              <span class="align-middle ml-50">Edit</span>
            </b-dropdown-item>

            <b-dropdown-item
              v-if="canViewThisAction('update', 'Suite')"
              @click="updateReservable(data.item._id, data.item.reservableBy)"
            >
              <span class="align-middle ml-50">Update Reservation Status</span>
            </b-dropdown-item>

            <b-dropdown-item
              v-if="canViewThisAction('update', 'Suite')"
              @click="updateSaleStatus(data.item._id, data.item.saleStatus)"
            >
              <span class="align-middle ml-50">Update Sale Status</span>
            </b-dropdown-item>

            <!-- <b-dropdown-item
              v-if="canViewThisAction('delete', 'Suite')"
              @click="deleteEntity(data.item._id)"
            >
              <span class="align-middle ml-50">Delete</span>
            </b-dropdown-item> -->
          </b-dropdown>
        </template>

      </b-table>
    </b-card>

    <div
      v-if="totalSuites > perPage"
      class="mx-2 mb-2"
    >
      <b-row>
        <!-- Pagination -->
        <b-col
          cols="12"
          sm="12"
          class="d-flex align-items-center justify-content-center pagination-content"
        >

          <b-pagination
            v-model="currentPage"
            :total-rows="totalSuites"
            :per-page="perPage"
            first-number
            last-number
            class="mb-0 mt-1 mt-sm-0"
            align="center"
            prev-text="Prev"
            next-text="Next"
          >
            <template #prev-text>
              <feather-icon
                icon="ChevronLeftIcon"
                size="18"
              />
              <span>Prev</span>
            </template>
            <template #next-text>
              <span>Next</span>
              <feather-icon
                icon="ChevronRightIcon"
                size="18"
              />
            </template>
          </b-pagination>

        </b-col>

      </b-row>
    </div>

    <b-modal
      id="modal-update-reservable"
      ref="update-reservable-modal"
      cancel-variant="flat-primary"
      modal-class="status-update-modal"
      ok-variant="success"
      ok-title="Update"
      cancel-title="Cancel"
      centered
      no-close-on-backdrop
      title="Update Reservable By"
      @ok="submitReservableForm"
    >
      <b-form @submit.prevent="submitReservableForm">
        <validation-observer
          ref="reservableEditForm"
        >
          <b-form-group
            label="Status*"
            label-for="h-activity-type-status"
          >
            <validation-provider
              #default="{ errors }"
              name="Status"
              vid="status"
              rules="required"
            >
              <v-select
                id="h-activity-type-status"
                v-model="reservableStatus"
                label="title"
                :options="reservableOptions"
                :reduce="title => title.code"
                :clearable="false"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </validation-observer>
      </b-form>
    </b-modal>

    <b-modal
      id="modal-update-sale-status"
      ref="update-sale-status-modal"
      cancel-variant="flat-primary"
      modal-class="status-update-modal"
      ok-variant="success"
      ok-title="Update"
      cancel-title="Cancel"
      centered
      no-close-on-backdrop
      title="Update Sales Status"
      @ok="submitSaleStatusForm"
    >
      <b-form @submit.prevent="submitSaleStatusForm">
        <validation-observer
          ref="saleStatusEditForm"
        >
          <b-form-group
            label="Status*"
            label-for="h-sale-status"
          >
            <validation-provider
              #default="{ errors }"
              name="Status"
              vid="status"
              rules="required"
            >
              <v-select
                id="h-sale-status"
                v-model="saleStatusValue"
                label="title"
                :options="saleStatusOptions"
                :reduce="title => title.code"
                :clearable="false"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </validation-observer>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BCard, BRow, BButton, BCol, BFormInput, BTable, BInputGroup, BInputGroupAppend,
  BImg, BDropdown, BDropdownItem, BPagination, BFormTag, BBadge, BForm, BFormGroup,
} from 'bootstrap-vue'
import { ref, onUnmounted } from '@vue/composition-api'
// eslint-disable-next-line import/no-cycle
import { avatarText } from '@core/utils/filter'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import store from '@/store'
import vSelect from 'vue-select'
import { required } from '@validations'
import { useUtils as useAclUtils } from '@/libs/acl/custom'
// eslint-disable-next-line import/no-cycle
import useSuiteList from './useSuiteList'
import suiteStoreModule from './suiteStoreModule'
import SuiteFilter from './SuiteFilter.vue'

export default {
  components: {
    // UserListAddNew,
    BForm,
    BFormGroup,
    BFormTag,
    BCard,
    BRow,
    BButton,
    BCol,
    BFormInput,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    BInputGroup,
    BInputGroupAppend,
    BImg,
    BBadge,

    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    SuiteFilter,

    ValidationProvider,
    ValidationObserver,
    vSelect,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      // eslint-disable-next-line global-require
      defaultImage: require('@/assets/images/placeholder/placeholder_image.png'),
      reservableOptions: [
        { title: 'Staff-only', code: 'Staff-only' },
        { title: 'Not for reservation', code: 'Not for reservation' },
        { title: 'All agents & Staff', code: 'All agents & Staff' },
      ],
      saleStatusOptions: [
        { title: 'Open Sales', code: 'Open Sales' },
        { title: 'Not for sale', code: 'Not for sale' },
        { title: 'Only from reservations', code: 'Only from reservations' },
      ],
      productOptions: [
        { title: 'Niche', code: '1' },
        { title: 'Pedestal', code: '5' },
        { title: 'Little Buddha', code: '6' },
      ],
      locationOptions: [],
      reservableStatus: 'Staff-only',
      saleStatusValue: 'Not for sale',
      toUpdateID: '',
      required,
    }
  },

  beforeMount() {
    this.$http.get('reservation/suite-location/respond-with/name-and-id')
      .then(response => {
        this.locationOptions = response.data.locations ?? []
      })
      .catch(error => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: error.data.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  },

  methods: {
    hideFilter() {
      this.$refs.filter_dropdown_locations.hide(true)
    },
    showFilter() {
      this.$refs.filter_dropdown_locations.show(true)
    },
    removeFromLocationFilter(location) {
      const index = this.locationFilter.indexOf(location)
      if (index > -1) {
        this.locationFilter.splice(index, 1)
      }
    },
    removeFromProductFilter(product) {
      const index = this.productFilter.indexOf(product)
      if (index > -1) {
        this.productFilter.splice(index, 1)
      }
    },
    removeFromReservableFilter(reservable) {
      const index = this.reservableFilter.indexOf(reservable)
      if (index > -1) {
        this.reservableFilter.splice(index, 1)
      }
    },
    removeFromSaleStatusFilter(saleStatus) {
      const index = this.saleStatusFilter.indexOf(saleStatus)
      if (index > -1) {
        this.saleStatusFilter.splice(index, 1)
      }
    },
    resolveLocationName(location) {
      const locationName = this.locationOptions.find(loc => loc._id === location)
      return locationName ? locationName.name : ''
    },
    resolveProductName(product) {
      // eslint-disable-next-line eqeqeq
      const productName = this.productOptions.find(prod => prod.code == product)
      return productName ? productName.title : ''
    },
    clearAllFilters() {
      this.locationFilter = []
      this.productFilter = []
      this.reservableFilter = []
      this.saleStatusFilter = []
    },
    updateReservable(id, status) {
      this.toUpdateID = id
      this.reservableStatus = status || 'Staff-only'
      this.$root.$emit('bv::show::modal', 'modal-update-reservable', '')
    },
    updateSaleStatus(id, status) {
      this.toUpdateID = id
      this.saleStatusValue = status || 'Not for sale'
      this.$root.$emit('bv::show::modal', 'modal-update-sale-status', '')
    },
    submitReservableForm() {
      this.$refs.reservableEditForm.validate().then(success => {
        if (success) {
          const formData = new FormData()
          formData.append('status', this.reservableStatus)

          this.$http.patch(`reservation/suites/${this.toUpdateID}/reservable/update`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
          })
            .then(() => {
              this.fetchSuites()
              this.$swal({
                title: 'Status Updated!',
                html: 'The status for this suite reservable by has been updated',
                // eslint-disable-next-line global-require
                imageUrl: require('@/assets/images/icons/save.png'),
                imageWidth: 80,
                imageHeight: 80,
                imageAlt: 'Custom Icon',
                showCancelButton: false,
                confirmButtonText: 'Okay',
                customClass: {
                  confirmButton: 'btn btn-primary',
                },
                buttonsStyling: false,
              })
            })
            .catch(error => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: error.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                  icon: 'AlertTriangleIcon',
                  variant: 'danger',
                },
              })
            })
        }
      })
    },
    submitSaleStatusForm() {
      this.$refs.saleStatusEditForm.validate().then(success => {
        if (success) {
          const formData = new FormData()
          formData.append('status', this.saleStatusValue)

          this.$http.patch(`reservation/suites/${this.toUpdateID}/sale-status/update`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
          })
            .then(() => {
              this.fetchSuites()

              this.$swal({
                title: 'Status Updated!',
                html: 'The sale status for this suite has been updated',
                // eslint-disable-next-line global-require
                imageUrl: require('@/assets/images/icons/save.png'),
                imageWidth: 80,
                imageHeight: 80,
                imageAlt: 'Custom Icon',
                showCancelButton: false,
                confirmButtonText: 'Okay',
                customClass: {
                  confirmButton: 'btn btn-primary',
                },
                buttonsStyling: false,
              })
            })
            .catch(error => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: error.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                  icon: 'AlertTriangleIcon',
                  variant: 'danger',
                },
              })
            })
        }
      })
    },
    deleteEntity(id) {
      this.$swal({
        title: 'Warning!',
        text: ' Are you sure you want to delete this?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, Delete!',
        cancelButtonText: 'No, Cancel',
        customClass: {
          confirmButton: 'btn btn-danger',
          cancelButton: 'btn btn-primary ml-1',
        },
        buttonsStyling: false,
      })
        .then(result => {
          if (result.value) {
            this.toDeletedID = id
            this.deleteSuite()
          }
        })
    },
  },
  setup() {
    const showSearchBar = ref(false)
    const showFilterOptions = ref(false)
    const SUITE_APP_STORE_MODULE_NAME = 'app-suites'

    // Register module
    if (!store.hasModule(SUITE_APP_STORE_MODULE_NAME)) store.registerModule(SUITE_APP_STORE_MODULE_NAME, suiteStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(SUITE_APP_STORE_MODULE_NAME)) store.unregisterModule(SUITE_APP_STORE_MODULE_NAME)
    })

    const { canViewThisAction } = useAclUtils()

    const {
      fetchSuites,
      tableColumns,
      perPage,
      currentPage,
      totalSuites,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refSuitesTable,
      refetchData,

      toDeletedID,
      deleteSuite,
      currentDataLength,
      itemListData,

      // UI
      resolveSaleStatusVariant,
      resolveReservableVariant,

      // Extra Filters
      locationFilter,
      productFilter,
      reservableFilter,
      saleStatusFilter,
    } = useSuiteList()

    if (searchQuery.value) {
      showSearchBar.value = true
    }

    return {
      // Sidebar
      fetchSuites,
      tableColumns,
      perPage,
      currentPage,
      totalSuites,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refSuitesTable,
      refetchData,
      showSearchBar,
      showFilterOptions,
      toDeletedID,
      deleteSuite,
      currentDataLength,
      itemListData,

      // Filter
      avatarText,
      canViewThisAction,

      // UI
      resolveSaleStatusVariant,
      resolveReservableVariant,

      // Extra Filters
      locationFilter,
      productFilter,
      reservableFilter,
      saleStatusFilter,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
.img-preview-block{
      box-sizing: border-box;
      width: 38px;
      height: 38px;
      border: 1px solid #D2DCEA;
      border-radius: 5px;
  }
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
